import { render, staticRenderFns } from "./NewsContentNew.vue?vue&type=template&id=59379e2c&scoped=true&"
import script from "./NewsContentNew.vue?vue&type=script&lang=js&"
export * from "./NewsContentNew.vue?vue&type=script&lang=js&"
import style0 from "./NewsContentNew.vue?vue&type=style&index=0&id=59379e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59379e2c",
  null
  
)

export default component.exports